export const stringOrEmptyString: (obj: any) => string = (obj: any) => obj?.toString() ?? "";

export function isIterable(obj: any) {
  return Symbol.iterator in Object(obj);
}

export function isNullOrEmpty(obj: any) {
  return isNull(obj) || obj === '';
}

export function isNull(obj: any) {
  return obj == null || obj == undefined;
}